import React from "react";

const PaymentSuccessPage = () => {
  return <div>Thank you for choosing us!</div>;
};

export default PaymentSuccessPage;
